import React from "react";
import Navigation from "./Navigation";

function Header() {
  return (
    <div>
      <Navigation />
    </div>
  );
}

export default Header;
